/* Sections: #comments (4), #topics (9), #ranking (6) */

const comments = [
  { id: 1, name: '影迷小王', text: '画质真的很清晰，终于找到不卡顿的免费高清电影平台了！更新也超快，每天都有新内容。', tag: '老用户', time: '3天前' },
  { id: 2, name: '追剧达人', text: '这个免费影视平台太香了，新剧当天就能看，高清电视剧资源全到离谱，再也不用到处找了。', tag: 'VIP用户', time: '1天前' },
  { id: 3, name: '电影爱好者', text: '界面简洁干净，没有乱七八糟的弹窗广告，高清在线观看体验一流。推荐给了身边所有朋友！', tag: '活跃用户', time: '5小时前' },
  { id: 4, name: '怀旧影迷', text: '资源整合做得很好，连一些冷门老片都能找到。全集免费不缓冲，久久影视真的用心了。', tag: '新用户', time: '刚刚' },
];

const topics = [
  { id: 1, name: '暑期档新片', heat: '9.8万热议', color: 'bg-accent-500' },
  { id: 2, name: '悬疑剧推荐', heat: '7.2万热议', color: 'bg-primary-500' },
  { id: 3, name: '经典港片回顾', heat: '6.5万热议', color: 'bg-secondary-500' },
  { id: 4, name: '高分纪录片', heat: '5.8万热议', color: 'bg-accent-400' },
  { id: 5, name: '国产动漫崛起', heat: '5.1万热议', color: 'bg-primary-400' },
  { id: 6, name: '周未观影指南', heat: '4.6万热议', color: 'bg-secondary-400' },
  { id: 7, name: '韩剧热门推荐', heat: '4.2万热议', color: 'bg-accent-300' },
  { id: 8, name: '科幻大片合集', heat: '3.9万热议', color: 'bg-primary-300' },
  { id: 9, name: '古装剧精选', heat: '3.5万热议', color: 'bg-secondary-300' },
];

const ranking = [
  { id: 1, rank: 1, title: '流浪地球3', type: '科幻 / 冒险', status: '热播中', badge: 'TOP1', badgeColor: 'bg-accent-500' },
  { id: 2, rank: 2, title: '隐秘的角落', type: '悬疑 / 剧情', status: '全集更新', badge: '热门', badgeColor: 'bg-primary-500' },
  { id: 3, rank: 3, title: '繁花', type: '年代 / 都市', status: '全集更新', badge: '推荐', badgeColor: 'bg-primary-400' },
  { id: 4, rank: 4, title: '狂飙', type: '刑侦 / 剧情', status: '全集完结', badge: '经典', badgeColor: 'bg-secondary-500' },
  { id: 5, rank: 5, title: '封神第二部', type: '奇幻 / 史诗', status: '热播中', badge: '新片', badgeColor: 'bg-accent-400' },
  { id: 6, rank: 6, title: '三体', type: '科幻 / 剧情', status: '全集更新', badge: '高分', badgeColor: 'bg-primary-300' },
];

export default function SectionsPart1() {
  return (
    <>
      {/* #comments */}
      <section id="comments" className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
            观众热评
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 max-w-md mx-auto">
            来自真实用户的使用反馈，听听大家怎么说
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {comments.map((item) => (
              <div
                key={item.id}
                className="bg-background-100 rounded-xl p-5 flex flex-col"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <span className="text-primary-600 font-heading font-bold text-sm">
                      {item.name.charAt(0)}
                    </span>
                  </div>
                  <div className="min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-medium text-foreground-900 truncate">{item.name}</span>
                      <span className="text-[10px] px-1.5 py-0.5 rounded bg-primary-50 text-primary-600 font-medium whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                    <div className="text-xs text-foreground-400 mt-0.5">{item.time}</div>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                  &ldquo;{item.text}&rdquo;
                </p>
                <div className="flex items-center gap-0.5 mt-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-primary-400 text-xs"></i>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #topics */}
      <section id="topics" className="py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 max-w-md mx-auto">
            当下最受关注的高清影视在线讨论，看看大家都在追什么
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((item) => (
              <div
                key={item.id}
                className="group flex items-center gap-3 bg-background-50 rounded-full px-5 py-2.5 cursor-pointer hover:shadow-md transition-all duration-200"
              >
                <div className={`w-2 h-2 rounded-full ${item.color} flex-shrink-0`}></div>
                <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.name}</span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #ranking */}
      <section id="ranking" className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
            热门排行
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 max-w-md mx-auto">
            本周高清电视剧与高清电影热度榜，实时更新不缓冲资源
          </p>
          <div className="max-w-3xl mx-auto space-y-3">
            {ranking.map((item) => (
              <div
                key={item.id}
                className="flex items-center gap-4 bg-background-100 rounded-xl p-4 hover:bg-background-200 transition-colors cursor-pointer"
              >
                <div className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center flex-shrink-0">
                  <span className={`text-sm font-heading font-bold ${item.rank <= 3 ? 'text-accent-500' : 'text-foreground-500'}`}>
                    {item.rank}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-900 truncate">{item.title}</div>
                  <div className="text-xs text-foreground-500 mt-0.5">{item.type}</div>
                </div>
                <div className="hidden sm:block text-xs text-foreground-400 whitespace-nowrap">{item.status}</div>
                <span className={`text-[10px] px-2 py-1 rounded-full ${item.badgeColor} text-background-50 font-medium whitespace-nowrap`}>
                  {item.badge}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}